import { mapState } from 'vuex';
export default {
  name: 'SelectStaticField',
  props: {
    value: {
      type: [String, Number],
      default: null
    },
    label: {
      type: String,
      required: true
    },
    selectOptions: {
      type: Array,
      default: () => []
    },
    canAddRule: {
      type: Boolean,
      default: false
    },
    dense: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState('app', ['color', 'inpOutlined', 'inpFilled'])
  }
};